<template>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn @click="emitPagination({first: true})" icon><v-icon>mdi-arrow-collapse-left</v-icon></v-btn>
    <v-btn @click="emitPagination({prev: true})" icon :disabled="!pagination.prev_page"><v-icon>mdi-arrow-left</v-icon></v-btn>
    <template v-if="pagination.to <= 15">
      <v-btn v-for="page in pagination.to" :key="page" @click="emitPagination({toPage: page})" :outlined="page === pagination.current_page" small icon label>{{page}}</v-btn>
    </template>
    <template v-else>
      <v-menu>
        <template v-slot:activator="{on:menu}">
          <v-tooltip top>
            <template v-slot:activator="{on:tooltip}">
              <v-btn v-on="{...tooltip,...menu}" icon>{{pagination.current_page}}</v-btn>
            </template>
            <span>Click to select a different page</span>
          </v-tooltip>
        </template>
        <v-list style="width: 120px;max-height: 300px;overflow-y:auto">
          <v-list-item v-for="page in pagination.to" :key="page" @click="emitPagination({toPage: page})">{{page}}</v-list-item>
        </v-list>
      </v-menu>
    </template>
    <v-btn @click="emitPagination(true)" icon :disabled="!pagination.next_page"><v-icon>mdi-arrow-right</v-icon></v-btn>
    <v-btn @click="emitPagination({last: true})" icon><v-icon>mdi-arrow-collapse-right</v-icon></v-btn>
    <v-spacer></v-spacer>
  </v-card-actions>
</template>

<script>
export default {
  name: "TablePaginationFooter",
  props:{
    store_model: {
      required: true,
    }
  },
  computed: {
    pagination(){
      return this.$store.state.entities[this.store_model].pagination
    },
  },
  methods: {
    emitPagination(next){
      this.$emit('next',next);
    }
  }
}
</script>

<style scoped>

</style>
